module.exports = __webpack_public_path__ + "img/order-charts.419ccf11.svg";